module.exports = __webpack_public_path__ + "static/img/5341_phase_function_Paper_Points.f0e3270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5341_phase_function_Paper_Points.png
// module id = +KVT
// module chunks = 0